let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3Yzkm"), load("3YQfj"), load("dRao7"), load("4Oj5y"), load("jsjHl"), load("hhss7"), load("eK94l")]).then(() => parcelRequire('8fb5x'));